import { render } from "./OTPDesign.vue?vue&type=template&id=8f8bc6a6&scoped=true"
import script from "./OTPDesign.vue?vue&type=script&lang=js"
export * from "./OTPDesign.vue?vue&type=script&lang=js"

import "./OTPDesign.vue?vue&type=style&index=0&id=8f8bc6a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f8bc6a6"]])

export default __exports__